var _title, _desc, _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAlertError = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Alert Error")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Alert Error")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.75,18.75 L16.25,18.75 L16.25,21.25 L13.75,21.25 L13.75,18.75 Z M13.75,8.75 L16.25,8.75 L16.25,16.25 L13.75,16.25 L13.75,8.75 Z M14.9875,2.5 C8.0875,2.5 2.5,8.1 2.5,15 C2.5,21.9 8.0875,27.5 14.9875,27.5 C21.9,27.5 27.5,21.9 27.5,15 C27.5,8.1 21.9,2.5 14.9875,2.5 Z M15,25 C9.475,25 5,20.525 5,15 C5,9.475 9.475,5 15,5 C20.525,5 25,9.475 25,15 C25,20.525 20.525,25 15,25 Z",
    id: "alert-error-path"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-error-Z---WORK",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert-error-09_PB_Selected_03_01",
    transform: "translate(-639.000000, -615.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert-error-Alert-Modal",
    transform: "translate(423.000000, 556.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert-error-ic/Alert-Error",
    transform: "translate(214.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert-error-ic_error_outline_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "alert-error-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#alert-error-path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "alert-error-Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "alert-error-c/grey/600-c/gold",
    mask: "url(#alert-error-mask-2)",
    fill: "#FF9B07"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "alert-error-Shape",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alert-error.203428b2.svg";
export { ForwardRef as ReactComponent };